<div class="open-slow" [ngClass]="{ 'open-slow-to-height': showNow }">
  @if (showSave) {
    <button
      mat-button
      class="celo-secondary-button button-hover m-1"
      (click)="save.emit($event)"
    >
      {{ textSave }}
    </button>
  }
  @if (showCancel) {
    <button
      mat-button
      class="celo-secondary-button button-hover thin-font m-1"
      (click)="cancelled.emit($event)"
    >
      {{ textCancel }}
    </button>
  }
</div>
